// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"8ba2c69c","232":"407e2bcc","237":"d5832c9a","526":"98ac4e95","787":"dbbd0357","872":"e8bfbb2e"}[chunkId] + ".chunk.js";
};